import React from 'react';
export function Settings() {
  return <div className="max-w-4xl mx-auto space-y-8" data-id="element-825">
      <div data-id="element-826">
        <h1 className="text-2xl font-semibold text-bone mb-2" data-id="element-827">Settings</h1>
        <p className="text-muted text-sm" data-id="element-828">
          Manage your account, API keys, and team members.
        </p>
      </div>

      <div className="bg-ink-2 border border-white/5 rounded-2xl overflow-hidden" data-id="element-829">
        <div className="px-6 py-4 border-b border-white/5" data-id="element-830">
          <h2 className="text-lg font-medium text-bone" data-id="element-831">API Keys</h2>
        </div>
        <div className="p-6 space-y-6" data-id="element-832">
          <div data-id="element-833">
            <label className="block text-sm font-medium text-bone-dim mb-2" data-id="element-834">
              Live Secret Key
            </label>
            <div className="flex gap-3" data-id="element-835">
              <input type="password" value="sk_live_xxxxxxxxxxxxxxxxxxxx" readOnly className="flex-1 px-4 py-2 bg-ink border border-white/10 rounded-lg text-sm text-bone mono focus:outline-none" data-id="element-836" />
              
              <button className="px-4 py-2 bg-ink-3 border border-white/10 rounded-lg text-sm font-medium text-bone hover:bg-ink-4 transition-colors" data-id="element-837">
                Reveal
              </button>
            </div>
            <p className="text-xs text-muted mt-2" data-id="element-838">
              Use this key to authenticate API requests in your live
              environment.
            </p>
          </div>

          <div className="pt-6 border-t border-white/5" data-id="element-839">
            <label className="block text-sm font-medium text-bone-dim mb-2" data-id="element-840">
              Webhook URL
            </label>
            <div className="flex gap-3" data-id="element-841">
              <input type="url" defaultValue="https://api.edgars.co.za/webhooks/masube" className="flex-1 px-4 py-2 bg-ink border border-white/10 rounded-lg text-sm text-bone focus:outline-none focus:border-mint focus:ring-1 focus:ring-mint" data-id="element-842" />
              
              <button className="px-4 py-2 bg-mint text-ink rounded-lg text-sm font-semibold hover:bg-mint-dim transition-colors" data-id="element-843">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-ink-2 border border-white/5 rounded-2xl overflow-hidden" data-id="element-844">
        <div className="px-6 py-4 border-b border-white/5 flex items-center justify-between" data-id="element-845">
          <h2 className="text-lg font-medium text-bone" data-id="element-846">Team Members</h2>
          <button className="text-sm text-mint hover:text-mint-dim font-medium" data-id="element-847">
            Invite Member
          </button>
        </div>
        <div className="divide-y divide-white/5" data-id="element-848">
          {[{
          name: 'Thandi Mokoena',
          email: 'thandi@edgars.co.za',
          role: 'Admin'
        }, {
          name: 'Sipho Khumalo',
          email: 'sipho@edgars.co.za',
          role: 'Developer'
        }, {
          name: 'Anna Van Der Merwe',
          email: 'anna@edgars.co.za',
          role: 'Finance'
        }].map((member, i) => <div key={i} className="px-6 py-4 flex items-center justify-between" data-id="element-849">
            
              <div data-id="element-850">
                <div className="text-sm font-medium text-bone" data-id="element-851">
                  {member.name}
                </div>
                <div className="text-xs text-muted" data-id="element-852">{member.email}</div>
              </div>
              <div className="flex items-center gap-4" data-id="element-853">
                <span className="text-xs text-bone-dim bg-ink-3 px-2 py-1 rounded" data-id="element-854">
                  {member.role}
                </span>
                <button className="text-xs text-muted hover:text-bone" data-id="element-855">
                  Edit
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}